module.exports = __webpack_public_path__ + "static/media/bg_loop.9d2ef93.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/nyf/mp3/bg_loop.mp3
// module id = /KtQ
// module chunks = 1